import { render, staticRenderFns } from "./PrinterDialogComponent.vue?vue&type=template&id=5475aca7"
import script from "./PrinterDialogComponent.vue?vue&type=script&lang=js"
export * from "./PrinterDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports